export default "__VITE_ASSET__c1fbd25a__"